import styled, { createGlobalStyle } from 'styled-components';

export const ColumnEditorGlobalStyle = createGlobalStyle`
    .column-editor-modal .ms-Dialog-main
    {
        width: auto !important;
        max-width: 90vw !important;
    }
`;

export const ModalContainer = styled.div`
    padding: 32px 40px;
    width: 860px;
    max-width: 90vw;
    box-sizing: border-box;
    overflow: hidden;
`;

export const Title = styled.h2`
    font-size: 24px;
    font-weight: 700;
    color: #323130;
    margin: 0 0 8px 0;
    cursor: default;
`;

export const Subtitle = styled.p`
    font-size: 14px;
    color: #605e5c;
    margin: 0 0 5px 0 !important;
    cursor: default;
`;

export const ColumnsLayout = styled.div`
    display: flex;
    gap: 48px;
    margin-top: 5px;
`;

export const LeftColumn = styled.div`
    flex: 0 0 260px;
`;

export const RightColumn = styled.div`
    flex: 1;
    min-width: 0;
`;

export const SectionTitle = styled.h3`
    font-size: 16px;
    font-weight: 700;
    color: #323130;
    margin: 0 0 4px 0;
    height: 22px;
    cursor: default;
`;

export const SectionSubtitle = styled.p`
    font-size: 13px;
    color: #605e5c;
    margin: 0 0 16px 0 !important;
    min-height: 20px;
    cursor: default;
`;

export const RadioGroup = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0;
`;

export const RadioItem = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    cursor: pointer;
    height: 46px;
`;

export const RadioCircle = styled.div<{ selected: boolean }>`
    width: 20px;
    height: 20px;
    border-radius: 50%;
    border: 2px solid ${(props) => props.selected ? '#CC214F' : '#8a8886'};
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
`;

export const RadioDot = styled.div`
    width: 13px;
    height: 13px;
    border-radius: 50%;
    background: #CC214F;
`;

export const RadioLabel = styled.span`
    font-size: 14px;
    color: #323130;
`;

export const ColumnList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0;
`;

export const ColumnRow = styled.div<{isDragging?: boolean}>`
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 46px;
    border-radius: 4px;
    padding: 0 4px;
    background: ${(props) => props.isDragging ? '#E0164C' : 'transparent'};
    box-shadow: ${(props) => props.isDragging ? '0 4px 12px rgba(0, 0, 0, 0.15)' : 'none'};

    &:hover
    {
        background: ${(props) => props.isDragging ? '#E0164C' : '#f9f9f9'};
    }

    ${(props) => props.isDragging && `
        & span
        {
            color: #ffffff;
        }
    `}
`;

export const ColumnLabel = styled.span`
    font-size: 14px;
    color: #323130;
    cursor: default;
`;

export const ColumnActions = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
`;

export const DragHandle = styled.span`
    color: #a19f9d;
    font-size: 18px;
    cursor: grab;
    user-select: none;
    width: 18px;
    text-align: center;
    flex-shrink: 0;

    &:active
    {
        cursor: grabbing;
    }
`;

export const DragHandleSpacer = styled.span`
    width: 18px;
    flex-shrink: 0;
`;

export const FooterContainer = styled.div`
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 12px;
    margin-top: 28px;
`;

export const CancelButton = styled.button`
    padding: 8px 24px;
    border-radius: 100px;
    background: transparent;
    border: 1px solid #CC214F;
    color: #CC214F;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;

    &:hover
    {
        background: rgba(204, 33, 79, 0.06);
    }
`;

export const SaveButton = styled.button`
    padding: 8px 24px;
    border-radius: 100px;
    background: #CC214F;
    border: 1px solid #CC214F;
    color: #ffffff;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;

    &:hover
    {
        background: #a81a40;
    }
`;